<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <approval-message-bell />
      <el-popover
        v-model="toolboxVisible"
        placement="bottom-end"
        width="360"
        trigger="click"
        popper-class="toolbox-popper"
      >
        <div class="toolbox-panel">
          <div class="toolbox-panel-header">
            <span>工具箱</span>
          </div>
          <div class="toolbox-grid">
            <div
              v-for="item in tools"
              :key="item.path"
              class="toolbox-grid-item"
              @click="handleToolCommand(item.path)"
            >
              <div class="toolbox-grid-icon">
                <i v-if="item.icon" :class="item.icon" />
                <span v-else>{{ getToolIconText(item.title) }}</span>
              </div>
              <span class="toolbox-grid-title">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div slot="reference" class="toolbox-icon right-menu-item hover-effect" title="工具箱">
          <span class="toolbox-trigger-symbol" aria-hidden="true">
            <span v-for="dot in 9" :key="dot" />
          </span>
        </div>
      </el-popover>
      <div v-if="tenants && tenants.length === 1" class="tenantNameClass right-menu-item">{{tenants[0].fullName}}</div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" @command="handleTenantCommand" v-if="tenants.length > 1">
        <div class="avatar-wrapper">
          <span class="tenant-name">{{tenants.find(item => item.tenantId === tenantId).fullName}}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <div v-for="item in tenants" :key="item.tenantId">
            <el-dropdown-item v-if="tenantId !== item.tenantId" :command="item.tenantId">
              <span>{{item.fullName}}</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <UserAvatar :url="avatar" :name="nickName"/>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/profile">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import UserAvatar from '@/views/system/user/userAvatar'
import { changeTenant } from '@/api/system/user'
import ApprovalMessageBell from './ApprovalMessageBell'

export default {
  components: {
    ApprovalMessageBell,
    Breadcrumb,
    Hamburger,
    UserAvatar,
    // SizeSelect,
    // RuoYiGit,
    // RuoYiDoc
  },
  data() {
    return {
      toolboxVisible: false,
      tools: [
        {
          title: '税率计算',
          path: '/toolbox/invoice-tax',
          icon: 'el-icon-document'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'nickName',
      'tenantId',
      'tenants',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
      })
    },
    handleTenantCommand(command) {
      changeTenant({tenantId: command}).then(response => {
        // location.reload();
        location.href = '/index';
      });
    },
    handleToolCommand(path) {
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
      this.toolboxVisible = false
    },
    getToolIconText(title) {
      return title ? title.substr(0, 1) : '工'
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .tenantNameClass {
    font-size: 14px !important;
    margin-right: 10px;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .toolbox-icon {
      width: 50px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .toolbox-trigger-symbol {
        display: grid;
        grid-template-columns: repeat(3, 4px);
        grid-auto-rows: 4px;
        gap: 3px;
        width: 20px;
        height: 20px;
        align-content: center;
        justify-content: center;

        span {
          width: 4px;
          height: 4px;
          border-radius: 1px;
          background: #409eff;
          box-shadow: 0 0 0 1px rgba(64, 158, 255, .08);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        margin-top: 5px;
        padding: 0 20px 0 0;
        position: relative;

        .tenant-name {
          font-size: 14px;
          vertical-align: middle;
          margin-top: -10px;
          display: inline-block;
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: 0;
          top: 12px;
          font-size: 12px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.toolbox-popper {
  padding: 0;

  .toolbox-panel {
    padding: 14px;
  }

  .toolbox-panel-header {
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 10px;
    color: #303133;
    font-size: 14px;
    font-weight: 600;
  }

  .toolbox-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .toolbox-grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 92px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    color: #606266;
    cursor: pointer;
    transition: all .2s;

    &:hover {
      border-color: #409eff;
      background: #ecf5ff;
      color: #409eff;
    }
  }

  .toolbox-grid-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-bottom: 8px;
    border-radius: 4px;
    background: #f0f7ff;
    color: #409eff;
    font-size: 20px;
    font-weight: 600;

    span {
      font-size: 17px;
      line-height: 36px;
    }
  }

  .toolbox-grid-title {
    display: block;
    width: 100%;
    padding: 0 6px;
    color: #303133;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
